export function isHTMLElement(x) {
  return x instanceof HTMLElement;
}
